import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Sidebar      from "./components/Sidebar";
import Login        from "./pages/Login";
import Dashboard    from "./pages/Dashboard";
import Cashflow     from "./pages/Cashflow";
import Revenue      from "./pages/Revenue";
import Inventory    from "./pages/Inventory";
import OKRs         from "./pages/OKRs";
import Customers    from "./pages/Customers";
import Orders       from "./pages/Orders";
import Products     from "./pages/Products";
import CapEx        from "./pages/CapEx";
import Admins       from "./pages/Admins";
import ZohoPage     from "./pages/Zoho";
import ShopifyPage  from "./pages/Shopify";
import MetaPage     from "./pages/Meta";

function Shell() {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ display:"flex", alignItems:"center", justifyContent:"center",
                  height:"100vh", fontSize:36 }}>🧵</div>
  );
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div style={{ display:"flex", minHeight:"100vh", background:"#FAF7F2" }}>
      <Sidebar />
      <main style={{ flex:1, minWidth:0, overflowX:"auto", overflowY:"auto", height:"100vh" }}>
        <Routes>
          <Route path="/"          element={<Dashboard />} />
          <Route path="/revenue"   element={<Revenue />} />
          <Route path="/cashflow"  element={<Cashflow />} />
          <Route path="/inventory" element={<Inventory />} />
          <Route path="/okrs"      element={<OKRs />} />
          <Route path="/customers" element={<Customers />} />
          <Route path="/orders"    element={<Orders />} />
          <Route path="/products"  element={<Products />} />
          <Route path="/capex"     element={<CapEx />} />
          <Route path="/admins"    element={<Admins />} />
          <Route path="/zoho"      element={<ZohoPage />} />
          <Route path="/shopify"   element={<ShopifyPage />} />
          <Route path="/meta"      element={<MetaPage />} />
        </Routes>
      </main>
    </div>
  );
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/*"     element={<Shell />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
